import { Component, inject } from '@angular/core';
import { ImportFlowService } from '@services/imports/import-flow.service';
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { VhmProFormaDataSource } from '@components/new-table/data-sources/vhm-pro-forma.dataSource';
import { VhmProFormaSettingsTable } from '@/table-settings/imports/vhm-pro-forma-settings-table';

@Component({
  selector: 'app-vhm-pro-forma-table',
  templateUrl: './vhm-pro-forma-table.component.html',
  styleUrls: ['./vhm-pro-forma-table.component.scss'],
})
export class VhmProFormaTableComponent {
  displayedColumns: TableColumnsSetting<any>;

  dataSource = new VhmProFormaDataSource(this.importFlowService);

  toastr = inject(ToastrService);
  dialog = inject(MatDialog);

  reloadTrigger$ = new Subject<any>();

  constructor(private importFlowService: ImportFlowService) {
    this.displayedColumns = VhmProFormaSettingsTable.getColumnsSetting();
  }
}
